import styled from "styled-components";

export const StyledQueryFilters = styled.div`
  display: flex;
  flex-flow: row wrap;
`;
